import { TERMS_OF_SERVICE_ROUTE_ID, COOKIE_POLICY_ROUTE_ID, PRIVACY_POLICY_ROUTE_ID, } from 'root/src/shared/descriptions/routes/routeIds';
import Link from 'root/src/client/web/base/Link';
import { RedesignAuthPage } from 'root/src/client/v2/_pages/auth/redesign/RedesignAuthPage';
import { NEW_USER_HIGHLIGHTS } from 'root/src/client/v2/_pages/auth/redesign/authPageHighlights';
import { useAuthPageMode } from 'root/src/client/v2/_pages/auth/redesign/useAuthPageMode';
const legalLinkClass = 'text-primary/70 no-underline transition-colors hover:text-primary';
// Legal caption from the legacy sign-up form (postSubmitCaption), with the three policies linked.
const SignUpLegalCaption = () => (<p className="pt-1 text-[11px] leading-relaxed text-muted-foreground/50">
		By signing up, you agree to our{' '}
		<Link routeId={TERMS_OF_SERVICE_ROUTE_ID} className={legalLinkClass}>terms of use</Link>,{' '}
		<Link routeId={PRIVACY_POLICY_ROUTE_ID} className={legalLinkClass}>privacy policy</Link>, and{' '}
		<Link routeId={COOKIE_POLICY_ROUTE_ID} className={legalLinkClass}>cookie policy</Link>.
		{' '}
		Our policies explain how we use your data to deliver, improve, and promote our service and our
		site, and how you can exercise your rights to control that use.
	</p>);
// Redesign of the legacy `/sign-up` page (SIGN_UP_FORM_MODULE_ID), served in place at that URL.
// Carries the two things the SignInDialog's sign-up panel leaves out because it is a quick
// in-context signup: the brand newsletter opt-in and the legal caption. The panel switch to sign-in
// navigates to `/sign-in` so each panel keeps its own URL.
export const RedesignSignUpPage = () => {
    const { mode, onModeChange } = useAuthPageMode({ initialMode: 'signup' });
    return (<RedesignAuthPage mode={mode} onModeChange={onModeChange} headline="Join Dare Drop" subheadline="Create an account to take on dares, earn rewards and work with the games you love." highlights={NEW_USER_HIGHLIGHTS} newsletterOptIn footnote={<SignUpLegalCaption />}/>);
};
